import React, { useEffect, useState } from "react";
import * as _ from "lodash";
import { Button , Drawer} from "@material-ui/core";
import * as XLSX from "xlsx"; 
import { IFormElement } from "../../Forms/interface/IFormElement";
import { FormElementHelper } from "../../Forms/helper/Utils/Element";
import { FILE_DOWNLOAD_API_URL } from "../../../../api/paths";
import { SubmitForm } from "../../Forms/helper/Forms/SubmitForm";
import { UIErrorOrNoteMessage } from "../Child/ErrorOrNote";
import ModalGrid from "./ModalGrid";
import moment from "moment";

//******* Important Configurations for sidebar with grid ***//////
// AddDynamicElements : Here need to add the aggrid header configuration mentioned in aggrid component
// HighlightRemovedOption - Will add delete button on UI
// AllowAll - used for selection checkbox
// isMulti: Allow multiple selection
// LoadDataToGrid- To load data grid
// SelectionLimit - Read from index, Mostly used to read data from specific row index in excel
// DynamicFieldLabel- valuesas "Download" which gives an button with the lable value given to download grid 
// DynamicConfiguration: for download file
// TemplateLabel :  It contains the array of component values to create download file name ex: [1394,1429,1410,1419] in meta creative
// allowedFileType: gives option to download file in a pdf or xlsx format.

interface RunQaObject {
  "qa_id": any,
  "qa_results":  any; // Define the type of qa_result (can be any type)
}
    
    
type Props = {
  formElement: IFormElement;
  onChange: any;
  formId: number;
  formGroupId: number;
  form: any;
};

export const ModelButton = (props: Props): React.JSX.Element => {
  const { formElement, form ,onChange,formGroupId,formId} = props;
  const [isModalOpen, setModalStatus] = useState(false);
  const [url, setUrl] = useState({flag:false,url:""}) ;
  const [updatedData, setUpdatedData] = useState<any>([]);
  const [gridData, setGridData] = useState({loader:false,gridData:[]});
  const [eleValue, setEleValue] = useState(formElement.value);
  const [message, setMessage] = useState("");
  const [runQa, setRunQa] = useState<RunQaObject>();
  const [errorGrid,setErrorGrid] = useState("");
  const errorMessageQA = "One or more creative(s) failed validation. Please review the creative(s) and resolve any issues before attempting to save.";
  
  
  useEffect(()=> {
    setEleValue(formElement.value);
  }, [formElement]);
  const handleOpenModal =  async ():Promise<any> => { 
    setModalStatus(true); 
    setGridData(prev=>({
      ...prev,
      loader:true,
      gridData:[]
      })); 
    await onLinkClick();
  };

  const checkFailed = (qa_results:any):boolean=>{
      return _.some(qa_results, item =>
        _.isEqual(item.result,"Fail") || (item.children && checkFailed(item.children))
    );
  };

  const handleCloseModal = ():any => {
    setModalStatus(false);
    setMessage("");
    let payload = updatedData;
    if(runQa) {
      const payloadObj: RunQaObject = runQa;
      payloadObj.qa_results = updatedData;
      payload = payloadObj;
    }  
    formElement.value = payload;
    if(checkFailed(payload.qa_results)){
      formElement.apiError = errorMessageQA;
    }
    else if(!_.isEmpty(errorGrid)){
      formElement.apiError = errorGrid;
    }
    else{formElement.apiError = "";}
    setErrorGrid("");
    onChange({
      formId,
      formGroupId,
      formElement,
      value: payload,
    });
  };
  
  let errorMessage = formElement.touched ? formElement.error : "";
  let disabled = formElement.disabled || formElement.read_only;
  if (!_.isEmpty(formElement.apiError)) {
    errorMessage = formElement.apiError;
    disabled = false;
  }

  const buttonLabel = formElement.labelName || "Default Label";
   
  const getDataFromApi = async ():Promise<any> => {
    const elementHelper = new FormElementHelper();
    try {
        const rs = await elementHelper.getAPIData([form], formElement,0,true);
        const data = rs.qa_results;
        data.forEach((item:any) => {
          if (item.ad_format) {
            item.ad_format = item.ad_format.label;
          } 
          if (item.ad_placement) {
            item.ad_placement = item.ad_placement.map((ad:any) => ad.label);
          }
        });
        setRunQa(rs);
        return  data;
    } catch (error:any) {
      console.log("run qa response error >>",error);
      setErrorGrid(error.message);
        return [];
    }
  };
  const onLinkClick = async (): Promise<any> => {    
    return new Promise((resolve) => {
      if (formElement.is_creatable_select) { // creatable select is used for excel load from bucket URL
        if(formElement.configuration_api_url) {
          const FileName = "MBQA_Report_act_1527246554779431_120205493304450517.xlsx";
          const LinkUrl = formElement.configuration_api_url; 
          setUrl({flag:!url.flag,url:`${process.env.REACT_APP_WPP_BACKEND_URL
            }${FILE_DOWNLOAD_API_URL}?filename=${FileName}&fileurl=${encodeURIComponent(
              LinkUrl
            )}`});
          resolve(true);
        } else { 
          const LinkUrl = eleValue.url || "";
          const FileName = eleValue.fileName || ""; //to download the file
          setUrl({flag:!url.flag,url:`${process.env.REACT_APP_WPP_BACKEND_URL
            }${FILE_DOWNLOAD_API_URL}?filename=${FileName}&fileurl=${encodeURIComponent(
              LinkUrl
            )}`}); 
            resolve(true);
        }       
      } else {
        (async () => {
        const gdata: any = await getDataFromApi();
        gdata?.forEach((item:any,index:number)=>{
          item.indexing = index;
        });

        setGridData(prev=>({
          ...prev,
          loader:false,
          gridData:gdata
          })); 
        setUpdatedData(gdata);
      })();
        resolve(true);
      }
    });
  };
  // Simulating an API call or side-effect
  useEffect(() => { 
    // Clean up function to reset states on unmount
    return () => { 
      // Reset all states
      setGridData({loader:false,gridData:[]});
      setUrl({flag:!url.flag,url:""}); 
    };
  }, []);
  const flattenTreeDataForExcel = (data : any, parent: any = null, level = 0):any => {
    return data
      .map((item: any) => {
        const flattenedItem = {
          ...item,
          parent: parent ? parent.fileName : null, // Track the parent fileName
        };
  
        // Recursively flatten the children and increase the level for deeper nodes
        const children = _.gt(item.children?.length, 0) ? flattenTreeDataForExcel(item.children, item, level + 1): [];
  
        return [flattenedItem, ...children]; // Return the flattened item and its children
      })
      .flat(); // Flatten the nested arrays into one array
  };
  
  // Function to remove the 'level' and 'parent' columns
  const removeUnwantedColumn = (data: any):any => {
    return data.map((item: any) => {
      // Create a shallow copy of the item
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { level, parent, children, childLevel, remove,  ...rest } = item; // Destructure and exclude 'level' and 'parent'
      return rest; // Return the remaining fields (without 'level' and 'parent')
    });
  };
  
   // Function to handle the export to Excel
   const exportFiles = ():any => { //NOSONAR
    const flatData = flattenTreeDataForExcel(updatedData);
    const modifiedData = removeUnwantedColumn(flatData);
    let downloadFileName = "data";
    if(formElement.template_label) {
      try {
        const submitForm: SubmitForm = new SubmitForm();
        const dependentFields = JSON.parse(formElement.template_label);
        const foundObjects = form.groups[0].elements.filter((obj: any )=> dependentFields.map(Number).includes(Number(obj.id)));
        const file_name : any = [];
        const formattedDate = moment(
          new Date()
        ).format("yyyy_MM_DD_HH_mm");
        foundObjects.forEach((element: any) => {       
          const eleVal = submitForm.getElementValue(element,true);
          if(eleVal) {
            if (Array.isArray(eleVal))
              file_name.push(eleVal.join("_"));
            else file_name.push(eleVal);
          }          
        });
        if(_.gt(file_name.length,0))
          downloadFileName = file_name.join("_")+"_"+formattedDate; 
      } catch(e) {
        console.log("Template Lable bust have valid data array", e);
      }
    }
    if(_.isEqual(formElement.allowed_file_type.toLocaleLowerCase(), null) || _.isEqual(formElement.allowed_file_type.toLocaleLowerCase(), "xlsx")) {
       // Convert JSON data to a worksheet
      const ws = XLSX.utils.json_to_sheet(modifiedData);
      // Create a new workbook
      const wb = XLSX.utils.book_new();    
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      // Trigger the download as an Excel file
      XLSX.writeFile(wb, downloadFileName +".xlsx");
    } else if (_.isEqual(formElement.allowed_file_type.toLocaleLowerCase(), "pdf")) {
      setMessage(downloadFileName);
    }
  };

  const textNote = ():any=>{
    if(!_.isNull(formElement.note)){
     return formElement.note.replace(/<\/?[^>]+(>|$)/g, "");

    }return "*  Only Passed Creative will be sent for further process";
 
  };
  
  return (
    <div>
      <Button onClick={()=>handleOpenModal()} disabled={formElement.disabled} variant="contained"
        color="primary">
        {buttonLabel}
      </Button> 
      <UIErrorOrNoteMessage
        formElement={formElement}
        errorMessage={disabled ? "" : errorMessage}
      />
      <Drawer anchor="right" open={isModalOpen} onClose={handleCloseModal}>
        <p slot="body" > 
        <div style={{
          width: 980,
        }}>
        <h6 slot="header" style={{color:"gray",fontSize:"14px",fontWeight:"500", paddingLeft:"20px"}}>{textNote()} </h6>

        </div>
          {formElement.load_data_to_grid && (
            <ModalGrid
              key={gridData ? gridData?.gridData?.length : 0}  // A simple way to force re-render when gridData changes
              url={url}
              headerFields={formElement.add_dynamic_elements}
              readFrom={formElement.selection_limit}
              gridData={gridData.gridData}
              loader={gridData.loader}
              updatedData={setUpdatedData}
              exportPdf={message}
              deleteButton={formElement.highlight_removed_option || false}
              isModalOpen={isModalOpen}
              setMessage = {setMessage}
            />
          
          
          )}         
        </p>
        <div slot="actions" style={{ paddingRight: "20px"}}>
        {formElement.dynamic_configuration && (  
            <Button 
              variant="contained"
              color="primary"
              disabled={_.isEqual(updatedData?.length,0)}
              style={{
                marginLeft: "0.75rem",
                float: "right"
              }}
              onClick={() => {
                exportFiles();
              }}
            >
              {formElement.dynamic_field_label}
            </Button>
          )}
          <Button
            color="primary"
            variant="outlined"
            onClick={handleCloseModal}
            style={{
              float: "right"
            }}
          >Continue</Button>
        </div>
        </Drawer>
    </div >
  );
};

export default ModelButton;